import React, { ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route, useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { AsyncComponent } from '../components';

import Routes, { isPublicRoute } from '../enums/routes';

import {
    getPractitionerSuccess,
    setPractitionerLanguages,
    setPractitionerSpecializations,
} from '../pods/user/state/actions';
import { authService } from '../services/AuthService';
import config from '../config';

import theme from '../styles/theme';
import { setOnboardingToComplete } from 'src/pods/onboarding/state/actions';
import { PractitionerStatus } from 'src/enums/practitioner.status';
import UserApiCalls from 'src/pods/user/api/ApiCalls';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IProps {}

const AppWrapper = styled.div<Omit<IProps, 'children'>>`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: ${theme.colors.light.grayscale['400']};
    position: relative;
    overflow-x: hidden;
    overflow-y: hidden;

    .app-body {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        overflow-x: hidden;

        .main {
            flex: 1;s
            min-width: 0;
        }
    }
`;

const Home = () => import('../pods/pages/Home');
const Terms = () => import('../pods/pages/Terms');
const TermsPortal = () => import('../pods/pages/ToSPortal');
const PrivacyPolicy = () => import('../pods/pages/PrivacyPolicy');

const AppLayout = (props: any): ReactElement => {
    const dispatch = useDispatch();
    const history = useHistory();

    const checkIfUserCompletedCourseAndNavigate = (status: PractitionerStatus) => {
        if (status === PractitionerStatus.PracticionerStatusAccepted) {
            return history.push(Routes.SUMMARY);
        }
        history.push(Routes.COURSE);
    };

    const navigateToLoginIfNeeded = () => {
        if (!isPublicRoute(props.match.path)) {
            return window.location.assign(`${config.SSO_APP_URL}/login?redirectURI=${config.PRACTITIONERS_APP_URL}`);
        }
    };

    const loadInitialData = async () => {
        try {
            dispatch(setOnboardingToComplete(true));
            const practitioner = await UserApiCalls.getPractitioner();
            checkIfUserCompletedCourseAndNavigate(practitioner.data.status);
            dispatch(getPractitionerSuccess(practitioner.data));
            dispatch(setPractitionerLanguages(practitioner.data.languages ?? []));
            dispatch(setPractitionerSpecializations(practitioner.data.specializations ?? []));
        } catch (error) {
            console.log(error);
        }
    };

    const onScreenLoad = async () => {
        if (authService.isAuthenticated()) {
            if (isPublicRoute(props.match.path)) {
                return history.push(props.match.path);
            }
            loadInitialData();
        }
        navigateToLoginIfNeeded();
    };

    useEffect(() => {
        onScreenLoad();
        // eslint-disable-next-line
    }, []);

    return (
        <AppWrapper>
            <div className="app-body">
                <main className="main">
                    <Switch>
                        <Route exact path={Routes.ROOT} component={AsyncComponent(Home)} />
                        <Route exact path={Routes.PRIVACY_POLICY} component={AsyncComponent(Terms)} />
                        <Route exact path={Routes.TERMS_AND_CONDITIONS} component={AsyncComponent(PrivacyPolicy)} />
                        <Route exact path={Routes.TERMS_PORTAL} component={AsyncComponent(TermsPortal)} />
                    </Switch>
                </main>
            </div>
        </AppWrapper>
    );
};

export default AppLayout;
